export default {

    1: [
        { text: 'OPÇÃO A', value: 1 },
    ],
    3: [
        { text: 'OPÇÃO A', value: 1 },
        { text: 'OPÇÃO B', value: 2 },
        { text: 'OPÇÃO C', value: 3 },
        { text: 'OPÇÃO D', value: 4 },
        { text: 'OPÇÃO E', value: 5 },
    ],
    4: [
        { text: 'OPÇÃO A', value: 1 },
        { text: 'OPÇÃO B', value: 2 },
    ],

}
